import React, { useState } from "react";
import Photos from "./Upload-photos";
import Videos from "./Videos";

function Upload() {
    const [activeTab, setActiveTab] = useState<"Photo" | "Video">("Photo");
    
    return (
        <div className="min-h-screen bg-gray-50 py-8 px-4">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">Content Upload</h1>
                
                {/* Tab Buttons */}
                <div className="flex mb-6 bg-white rounded-lg shadow p-1">
                    <button
                        onClick={() => setActiveTab("Photo")}
                        className={`flex-1 py-2 px-4 rounded-md font-medium transition-colors ${
                            activeTab === "Photo"
                                ? "bg-blue-600 text-white"
                                : "text-gray-600 hover:text-gray-900"
                        }`}
                    >
                        Upload Photos
                    </button>
                    <button
                        onClick={() => setActiveTab("Video")}
                        className={`flex-1 py-2 px-4 rounded-md font-medium transition-colors ${
                            activeTab === "Video"
                                ? "bg-blue-600 text-white"
                                : "text-gray-600 hover:text-gray-900"
                        }`}
                    >
                        Upload Videos
                    </button>
                </div>

                {/* Tab Content */}
                <div className="bg-white rounded-lg shadow-lg p-6">
                    {activeTab === "Photo" ? <Photos /> : <Videos/>}
                </div>
            </div>
        </div>
    );
}

export default Upload;